export enum INPUT_VARIANTS {
  plain = 'plain',
  search = 'search',
  phoneVerification = 'phoneVerification',
  textarea = 'textarea',
  autocomplete = 'autocomplete',
  checkbox = 'checkbox',
  label = 'label',
  dropdown = 'dropdown',
  dropdownSearch = 'dropdownSearch',
  phoneNumber = 'phoneNumber',
}
